/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
export * as operations from './operations';
export * from './data-contracts';
/** Version of the API specification */
export const specVersionHash = "611b7e957210c77fa513bbd5c069cb7ae551bd1a907e2dd3144f536b1eb8d39d";